import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../../Constant.js";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupText,
  InputGroup,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import { FaEnvelope, FaLock, FaEye, FaEyeSlash } from "react-icons/fa";
import Home2Navbar from "./Home2Navbar";
import Home2Footer from "./Home2Footer";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [emailId, setEmailId] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpError, setOtpError] = useState(false);
  const [otpExpires, setOtpExpires] = useState(null);
  const [newpassword, setNewPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [resetEmail, setResetEmail] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [timer, setTimer] = useState(0);

  useEffect(() => {
    if (otpSent && !otpVerified) {
      const interval = setInterval(() => {
        setTimer((prev) => (prev > 0 ? prev - 1 : 0));
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [otpSent, otpVerified]);

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" : ""}${s}`;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!emailId) {
      toast.warn("Please enter your email");
      return;
    }

    try {
      const response = await fetch(API_URL + "api/Login/ForgotPassword", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ Email: emailId }),
      });

      const result = await response.json();

      if (result.message === "User not found.") {
        toast.error("User Not Found, please check your email");
      } else if (response.ok) {
        toast.success("OTP sent to your email");
        setOtpSent(true);
        setResetEmail(emailId);
        setOtpExpires(Date.now() + 5 * 60 * 1000);
        setTimer(300); // Start 5 min timer
      } else {
        toast.error("Failed to send OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error("An error occurred. Please try again later.");
    }
  };

  const handleVerifyOTP = async () => {
    if (!otp) {
      toast.warn("Please enter the OTP");
      return;
    }

    if (Date.now() > otpExpires) {
      toast.error("OTP expired. Please request a new OTP.");
      setOtpSent(false);
      setOtp("");
      return;
    }

    try {
      const response = await fetch(API_URL + "api/Login/VerifyOtp", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ Email: emailId, Otp: otp }),
      });

      const result = await response.json();

      if (response.ok) {
        toast.success("OTP Verified!");
        setOtpVerified(true);
        setOtpError(false);
      } else {
        setOtpError(true);
        toast.error("Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  const handleResendOTP = () => {
    setOtpSent(false);
    setOtp("");
    handleSubmit(new Event("submit"));
  };

  const handleUpdatePassword = async () => {
    if (newpassword !== confirmpassword) {
      toast.error("Passwords do not match");
      return;
    }

    const data = {
      EmailId: resetEmail,
      Password: newpassword,
      ConfirmPassword: confirmpassword,
    };

    try {
      const response = await fetch(API_URL + "api/Login/UpdatePassword", {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        confirmAlert({
          customUI: ({ onClose }) => (
            <div
              style={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                padding: "20px",
                border: "1px solid lightgray",
                borderRadius: "10px",
                backgroundColor: "white",
                textAlign: "center",
                zIndex: 1000,
              }}
            >
              <h4>Password Updated</h4>
              <p>Your password has been updated successfully.</p>
              <button
                onClick={() => {
                  onClose();
                  navigate("/login");
                }}
                style={{
                  backgroundColor: "#4CAF50",
                  color: "white",
                  border: "none",
                  padding: "8px 12px",
                  cursor: "pointer",
                  borderRadius: "3px",
                }}
              >
                OK
              </button>
            </div>
          ),
        });
      } else {
        toast.error("Failed to update password");
      }
    } catch (error) {
      console.error("Error updating password:", error);
      toast.error("Something went wrong");
    }
  };

  return (
    <>
      <Home2Navbar />
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          minHeight: "50vh",
          background: "linear-gradient(to left,#fcfcfe)",
        }}
      >
        <Card
          style={{
            width: "100%",
            maxWidth: "450px",
            minHeight: "400px",
            boxShadow: "0px 0px 5px rgba(0,0,0,0.1)",
            borderRadius: "10px",
            padding: "24px",
            border: "none",
            marginBottom: "35px",

          }}
        >
          <h4 className="mb-2" style={{ color: "#080c77", textAlign: "left" }}>
            <b>Forgot Password</b>
            <br />
          </h4>
          <p
            className="text-left text-muted mb-4"
            style={{ fontSize: "15px", color: "#777" }}
          >
            {otpVerified
              ? "Enter your new password below."
              : otpSent
              ? "Check your email for the OTP and enter it below."
              : "Enter your registered email to receive an OTP."}
          </p>
          <CardBody style={{ padding: "0px" }}>
            <Form onSubmit={handleSubmit}>
              <FormGroup>
                <label
                  htmlFor="email"
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    color: "#716e77",
                  }}
                >
                  Email
                </label>
                <Input
                  placeholder="Enter your email"
                  type="email"
                  value={emailId}
                  onChange={(e) => setEmailId(e.target.value)}
                  required
                  disabled={otpSent}
                  style={{
                    fontSize: "15px",
                    padding: "20px",
                    border: "1px solid rgb(242, 241, 245)",
                    borderRadius: "5px",
                    backgroundColor: "#fcfefe",
                    outline: "none",
                    boxShadow: "none",
                  }}
                  onFocus={(e) => (e.target.style.border = "1px solid #080c77")}
                  onBlur={(e) =>
                    (e.target.style.border = "1px solid rgb(242, 241, 245)")
                  }
                />
              </FormGroup>

              {otpSent && !otpVerified && (
                <>
                  <FormGroup>
                    <label
                      htmlFor="otp"
                      style={{
                        fontSize: "15px",
                        fontWeight: "bold",
                        color: "#716e77",
                      }}
                    >
                      OTP
                    </label>
                    <Input
                      placeholder="Enter OTP"
                      type="text"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      required
                      style={{
                        fontSize: "15px",
                        padding: "20px",
                        border: "1px solid rgb(242, 241, 245)",
                        borderRadius: "5px",
                        backgroundColor: "#fcfefe",
                        outline: "none",
                        boxShadow: "none",
                      }}
                      onFocus={(e) =>
                        (e.target.style.border = "1px solid #080c77")
                      }
                      onBlur={(e) =>
                        (e.target.style.border = "1px solid rgb(242, 241, 245)")
                      }
                    />
                    {otpError && (
                      <p style={{ color: "red", fontSize: "13px" }}>
                        Invalid OTP. Please try again.
                      </p>
                    )}
                    <p
                      className="text-muted text-center"
                      style={{ fontSize: "13px" }}
                    >
                      OTP expires in: {formatTime(timer)}
                    </p>
                  </FormGroup>
                  <div className="d-grid gap-2">
                    <Button color="#de0f3f" onClick={handleVerifyOTP}>
                      Verify OTP
                    </Button>
                    <Button color="#080c77" onClick={handleResendOTP}>
                      Resend OTP
                    </Button>
                  </div>
                </>
              )}

              {otpVerified && (
                <>
                  <FormGroup>
                    <label
                      htmlFor="new-password"
                      style={{
                        fontSize: "15px",
                        fontWeight: "bold",
                        color: "#716e77",
                      }}
                    >
                      New Password
                    </label>
                    <Input
                      placeholder="New Password"
                      type={showPassword ? "text" : "password"}
                      value={newpassword}
                      onChange={(e) => setNewPassword(e.target.value)}
                      required
                      style={{
                        fontSize: "15px",
                        padding: "20px",
                        border: "1px solid rgb(242, 241, 245)",
                        borderRadius: "5px",
                        backgroundColor: "#fcfefe",
                        transition: "border 0.3s ease",
                        outline: "none",
                        boxShadow: "none",
                      }}
                      onFocus={(e) =>
                        (e.target.style.border = "1px solid #080c77")
                      }
                      onBlur={(e) => (e.target.style.border = "1px solid rgb(242, 241, 245)")}
                    />
                  </FormGroup>

                  <FormGroup>
                    <label
                      htmlFor="confirm-password"
                      style={{
                        fontSize: "15px",
                        fontWeight: "bold",
                        color: "#716e77",
                      }}
                    >
                      Confirm Password
                    </label>
                    <Input
                      placeholder="Confirm Password"
                      type={showConfirmPassword ? "text" : "password"}
                      value={confirmpassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                      style={{
                        fontSize: "15px",
                        padding: "20px",
                        border: "1px solid rgb(242, 241, 245)",
                        borderRadius: "5px",
                        backgroundColor: "#fcfefe",
                        transition: "border 0.3s ease",
                        outline: "none",
                        boxShadow: "none",
                      }}
                      onFocus={(e) =>
                        (e.target.style.border = "1px solid #080c77")
                      }
                      onBlur={(e) => (e.target.style.border = "1px solid rgb(242, 241, 245)")}
                    />
                  </FormGroup>

                  <div className="d-grid gap-2">
                    <Button color="#080c77" onClick={handleUpdatePassword}>
                      Update Password
                    </Button>
                  </div>
                </>
              )}

              {!otpSent && !otpVerified && (
                <div className="d-grid gap-2">
                  <center>
                    <Button
                      type="submit"
                      className="btn btn-sm btn-custom btn-join-counselor-custom"
                      style={{
                        backgroundColor: "#de0f3f",
                        borderColor: "#de0f3f",
                        color: "#fff",
                      }}
                    >
                      Send OTP
                    </Button>
                  </center>
                </div>
              )}

              <div className="text-center mt-3">
                <a
                  href="/login"
                  className="fw-bold text-decoration-none"
                  style={{ color: "#080c77" }}
                >
                  Back to Login
                </a>
              </div>
            </Form>
          </CardBody>
        </Card>
      </div>
      <Home2Footer />
      <ToastContainer />
    </>
  );
};

export default ForgotPassword;
